// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__rCAud","cardHeading":"styles_cardHeading___FpL3","cardBody":"styles_cardBody___Y5nZ"};